<template>
  <div class="columns">
    <div class="column is-flex">
      <div class="boxWithBorder">
        <div class="">
        <h3 class="subtitle has-text-weight-bold">Need support with your TripCircuit online booking?</h3>
        <p>Email Gant's Online Team:
          <a href="mailto:clientservices@ganttravel.com">
            clientservices@ganttravel.com
          </a>
        </p>
      </div>
      </div>
    </div>
    <div class="column is-flex">
      <div class="boxWithBorder">
        <div class="">
          <h3 class="subtitle has-text-weight-bold">Booking Same-Day Travel or need After-Hours assistance? </h3>
          <p>Contact Gant Travel directly for agent assistance at  877-924-0303</p>
        </div>
      </div>
    </div>
    <div class="column is-one-third">
      <div class="boxWithBorder">
        <div class="">
          <h3 class="subtitle has-text-weight-bold">Traveling Internationally?</h3>
          <p>
            <a href="https://cibtvisas.com/gant-travel?login=ganttravel" target="_blank">
              View International Visa Requirements
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'HomeWelcomeMessage'
    }

</script>

<style scoped>
</style>
